export default {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  ARCHIVED: 'ARCHIVED',
  DEACTIVATED: 'DEACTIVATED',
};
